// extracted by mini-css-extract-plugin
module.exports = {"actions":"FormControlCourses_actions__2acbz"};